<template>
  <div class="block-legal-container">
    <div @click="expanded = !expanded" class="expander">
      ПОДРОБНЫЕ УСЛОВИЯ АКЦИИ
    </div>

    <div v-show="expanded">
      <div class="legal-text-block">
        1 Указанная максимальная выгода/минимальная цена на автомобиль
        достигается при сочетании актуальных действующих программ и акций,
        подходящих под конкретную модель / комплектацию HAVAL: снижением
        стоимости нового автомобиля по программе трейд-ин, оценки стоимости
        выкупа автомобиля клиента, выгоды по кредитным продуктам, снижения
        стоимости на дополнительное оборудование, скидок, предоставляемых
        дилером на новый автомобиль при приобретении при посредничестве дилера
        страховых продуктов. Размер выгоды на автомобиль будет зависеть от
        выбранных клиентом финансовых и страховых продуктов, участия в программе
        трейд-ин и выбранного к покупке нового автомобиля. Не оферта (ст. 437 ГК
        РФ). Действует по 31.12.{{ year }}. Все подробности уточняйте у менеджеров: {{ CONSTANTS.phone }}

        <br /><br />2 Указана максимальная выгода, которая складывается из скидки на автомобиль; 
        подарка дополнительным оборудованием; выгоды по программе трейд-ин; 
        выгоды при покупке в кредит; выгоды при страховании. 
        Предложение не является публичной офертой, определяемой Ст.437 ГК РФ. 
        Предложение действует с 01.11.2023 г. Информация по телефонам дилерских центров.

        <br /><br />3 «HAVAL Protection+» - программа постгарантийного
        страхования. Подробности:
        https://haval-avtomir.ru/purchase/haval-protection/

        <br /><br />4 5 лет поддержки включают 3 года гарантии и 2 года программы постгарантийного обслуживания. Подробности:
        https://haval-avtomir.ru/owners/service/guarantee/

        <br /><br />5 «КАСКО в подарок и/или Сигнализация» - маркетинговая
        акция, которая предполагает предоставление клиенту выгоды, равной
        стоимости сигнализации и/или КАСКО на выбранный автомобиль, при условии
        покупки автомобиля в кредит и по программе трейд-ин; итоговая выгода
        зависит от условий покупки. Акция распространяется только на физических
        лиц. Все подробности уточняйте у менеджеров: {{ CONSTANTS.phone }}

        <br /><br />6 При покупке автомобиля HAVAL менеджер выдаёт покупателю
        бонусную карту, на которую начисляется до 50 000 бонусов = 50 000 рублей,
        которые можно потратить в соответствии с дисконтной программой ГК
        АВТОМИР https://avtomir.ru/discount/

        <br /><br />7 «Подарок за 150 000 руб.» - маркетинговая акция, которая предполагает 
        предоставление клиенту выгоды, равной 150 000 руб., или предоставление в подарок доп. 
        оборудования на выбранный автомобиль на сумму 150 000 руб., при условии покупки автомобиля 
        в кредит и по программе трейд-ин; итоговая выгода зависит от условий покупки. 
        Акция распространяется только на физических лиц. Все подробности уточняйте у менеджеров ДЦ АВТОМИР.

        <!-- <br /><br />7 *Госпрограмма действует на автомобили Haval Jolion, приобретенные в кредит, предоставленный одним из банков-партеров, под залог приобретаемого автомобиля, предоставляется субсидия  на уплату первоначального взноса в размере 20% от стоимости приобретаемого автомобиля. Действие программы  распространяется только на новые автомобили Haval Jolion, произведенные на территории Российской Федерации,  ЭПТС на которые оформлен не ранее 01.12.2022, пробег – 0 км. Стоимость приобретаемого автомобиля с учетом его комплектации — не более 2 млн руб.
        <br>
        Кредит предоставляется заемщикам, гражданами Российской Федерации, имеющими водительское удостоверение и отвечающими одновременно следующим условиям: имеют несовершеннолетнего ребенка (детей), в том числе находящегося под опекой или под попечительством, либо до даты заключения кредитного договора не имели в собственности автомобиль, либо являются работниками медицинских организаций государственной системы здравоохранения, либо работниками государственных и муниципальных образовательных организаций, либо в счет уплаты части первоначального взноса по кредиту продают свой автомобиль, возраст которого согласно сведениям паспорта транспортного средства превышает 6 лет и который находится в собственности у заемщика не менее одного года, либо заключают кредит на приобретение электромобиля, либо  являются гражданами Российской Федерации, проходящими военную службу по контракту или военную службу по призыву в соответствии с Федеральным законом “О воинской обязанности и военной службе”, либо являются супругом (супругой), детьми или родителями, проживающими совместно с гражданами Российской Федерации, проходящими военную службу по контракту или военную службу по призыву в соответствии с Федеральным законом “О воинской обязанности и военной службе”, либо являются пенсионерами, ранее проходившими военную службу, либо являются инвалидами; не заключали в году, предшествующем году заключения кредитного договора, иных кредитных договоров на приобретение автомобиля, что подтверждается кредитным отчетом, представляемым бюро кредитных историй в соответствии со статьей 6 Федерального закона “О кредитных историях”, а также обязуются не заключать в текущем году иных кредитных договоров на приобретение автомобиля, что подтверждается письменными заявлениями заемщиков, представляемыми в кредитную организацию.
        <br>
        Предложение не является публичной офертой. Полный перечень условий и требований программ льготного автокредитования по программе государственного субсидирования можно получить у официального дилера HAVAL по адресу: {{ CONSTANTS.address }} или у банков-партнеров. Кредит предоставляет Банк-кредитор: ПАО «Совкомбанк» (Генеральная лицензия Банка России №963 от 05 декабря 2014), ООО “Драйв Клик Банк” (Универсальная лицензия Банка России №2168 от 09 декабря 2022). -->

        <!-- <br /><br />9 Организатор ООО «АМКапитал». Подробную информацию об 
        организаторе акции, сроках, месте, условиях участия, количестве призов и 
        условиях их получения можно узнать в ДЦ HAVAL Автомир. Предложение 
        ограничено, количество подарков ограниченно, акция проходит с 25 по 26 
        ноября 2023 г… ПОДАРОК получат первые 20 участников прошедшие тест-драйв, 
        и принявшие участие в квесте «Важен каждый день» в ДЦ в период с 25 по 
        26 ноября 2023г. Прохождение квеста НЕ предусматривает использование 
        интернета и других средств со стороны участников.  Организатор оставляет 
        за собой право на внесение изменений в условия проведения акции. -->
        
        <br /><br />Предложение ограниченно, количество автомобилей участвующих
        в акции ограниченно. Не является офертой. УСЛОВИЯ КРЕДИТОВАНИЯ И
        БАНКИ-УЧАСТНИКИ МОГУТ БЫТЬ ИЗМЕНЕНЫ, УТОЧНЯЙТЕ ВСЕ ПОДРОБНОСТИ ПО
        УКАЗАННОМУ ТЕЛЕФОНУ.

        <br /><br />Все подробности предоставления кредитной программы и полные
        условия уточняйте у менеджеров ДЦ Автомир по телефону: {{ CONSTANTS.address }}, {{ CONSTANTS.phone }}. ВСЕ УСЛОВИЯ КРЕДИТОВАНИЯ
        МОГУТ БЫТЬ ИЗМЕНЕНЫ БАНКОМ, УТОЧНЯЙТЕ ИНФОРМАЦИЮ В САЛОНЕ!

        <br /><br />Обращаем Ваше внимание на то, что данный интернет-сайт носит
        исключительно информационный характер и ни при каких условиях не
        является публичной офертой, определяемой положением п. 2 ст. 437
        Гражданского кодекса Российской Федерации. Для получения подробной
        информации о стоимости автомобилей, максимальных выгодах по ним, а также
        по всем действующим акциям и предложениям, указанным на сайте,
        пожалуйста, обращайтесь к менеджерам отдела продаж ДЦ АВТОМИР по тел. {{ CONSTANTS.phone }}. Предоставляя свои персональные данные и используя
        настоящий веб-сайт, Вы соглашаетесь с обработкой Ваших персональных
        данных и принимаете условия их обработки. Политика конфиденциальности

        <!-- <br><br>9 ГОСПРОГРАММА -20%: Выгода в размере 20% от стоимости автомобиля в рамках государственной программы автокредитования может предоставляться гражданам Российской Федерации, которые являются работниками образовательных или медицинских организаций государственной системы здравоохранения, либо являются военнослужащими СВО или их родственниками, проживающими с ними совместно . Действует на новые автомобили HAVAL Jolion. Выпуска c 01.12.2022. Ограничений по сроку кредитования нет. Программа имеет перечень условий и требований, список документов, которые должны быть соблюдены для участия в данной программе. Полный перечень условий и требований программ льготного автокредитования, другие условия: по участвующим а/м, по стоимости а/м HAVAL, сумме ежемесячного платежа и пр. можно получить у официального дилера: Москва, Дмитровское ш., 98, стр. 1, +7 (495) 266‑99‑70. Предложение ограниченно, количество автомобилей участвующих в акции ограниченно. Действует до 30.04.2023. Не является офертой. -->
      </div>
    </div>
  </div>
</template>

<script>
import { CURRENT_YEAR } from '../common/date';

export default {
  name: "block-legal",
  components: {},
  directives: {},
  mixins: [],
  props: [""],
  data() {
    return {
      expanded: false,
      year: CURRENT_YEAR,
    };
  },
  computed: {
    lastDayOfMonth() {
      const today = new Date(Date.now() + 10800000);
      const lastDayCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      return new Date(lastDayCurrentMonth).toLocaleDateString("ru", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    firstDayOfMonth() {
      const today = new Date(Date.now() + 10800000);
      const firstDayCurrentMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      return new Date(firstDayCurrentMonth).toLocaleDateString("ru", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.expander {
  color: var(--button_common);
  cursor: pointer;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
}

.block-legal-container {
  font-size: 14px;
  font-weight: 300;
  max-width: 1600px;
  padding: 30px 10px;
}

.legal-text-block {
  margin-top: 15px;
}
</style>
